<template>
<div class="chapter">
<div class="inner_page">
<div id="regiment">
<div class="image-wrap" style="margin-top:2em;">
<div class="image">
<img alt="image" src="images/intro-2.jpg" style="max-width:100%"/>
</div>
</div>
<p class="paracenter">TITLES OF THE REGIMENT</p>
<p class="paracenter" style="margin-top:2em;">1817<br/>Cuttack Legion</p>
<p class="paracenter" style="margin-top:0.8em;">1823<br/>Rangpur Local Battalion<br/>8th Rangpur Light Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1827<br/>Assam Light Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1861<br/>42nd Regiment of Bengal Native (Light) Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1865<br/>46th Regiment of Bengal Native Infantry<br/>42nd Assam Regiment of Bengal Native Light Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1885<br/>42nd Bengal Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1886<br/>42nd Gurkha Light Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1891<br/>42nd Gurkha Rifle Regiment of Bengal Infantry</p>
<p class="paracenter" style="margin-top:0.8em;">1901<br/>42nd Gurkha Rifles</p>
<p class="paracenter" style="margin-top:0.8em;">1903<br/>6th Gurkha Rifles</p>
<p class="paracenter" style="margin-top:0.8em;">1959<br/>6th Queen Elizabeth’s Own Gurkha Rifles</p>
<div class="image-wrap" style="margin-top:2em;">
<div class="image">
<img alt="image" src="images/intro-3.jpg" style="max-width:100%"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14_regiment.vue?37199bc8